import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IServiceState } from '../interfaces/service-state.interface';
import { SceneToken } from '../enums/scene-token.enum';

const serviceState: IServiceState = {
  quizId: undefined,
  mode: undefined,
  domain: "",
  distributorAnswers: [],
  questionFilters: {},
  leadExtraParams: {},
  url: "",
  extra: {},
  abTests: [],
  initialPageIndex: SceneToken.START_PAGE,
  theme: "light",
  yaClientIdButtonActive: false,
  yandexIdAuthorized: false,
  test: false
}

export const serviceSlice = createSlice({
  name: "service",
  initialState: serviceState,
  reducers: {
    updateState: (state, action: PayloadAction<Partial<typeof serviceState>>) => {
      return {
        ...state,
        ...action.payload,
        leadExtraParams: {
          ...state.leadExtraParams,
          ...action.payload.leadExtraParams
        }
      };
    },

    addLeadExtraParams: (state, action: PayloadAction<Record<string, any>>) => {
      return { ...state, leadExtraParams: { ...state.leadExtraParams, ...action.payload } }
    },

    addExtraParams: (state, action: PayloadAction<Record<string, any>>) => {
      return { ...state, extra: { ...state.extra, ...action.payload } }
    },

    pushAbTest: (state, action: PayloadAction<any>) => {
      state.abTests.push(action.payload);
    },

    setInitialPage: (state, action: PayloadAction<SceneToken>) => {
      state.initialPageIndex = action.payload;
    }
  }
});

export const { updateState, pushAbTest, setInitialPage, addExtraParams, addLeadExtraParams } = serviceSlice.actions;
export default serviceSlice.reducer;